import { useEffect, useRef, useState } from 'react';
import { svgs } from '../assets/svgs'

export const CarouselSlider = ({ children, data, autoPlay = true }) => {
   const [touchPosition, setTouchPosition] = useState(null)
   const [slides, setSlides] = useState([]);
   const [currSlideIdx, setCurrSlideIdx] = useState(0);
   const [intIdx, setIntIdx] = useState(0);
   const slidesRef = useRef(null)
   const indicatorsRef = useRef(null)

   useEffect(() => {
      window.addEventListener('resize', handleResize);
      return () => {
         window.removeEventListener('resize', handleResize);
      };
   }, [])

   useEffect(() => {
      if (children.length === 0) return
      setSlides(Array.from(slidesRef.current.children));
   }, [children])

   useEffect(() => {
      if (!slides.length) return
      const currSlide = slides[currSlideIdx]
      slidesRef.current.style.transform = 'translateX(-' + currSlide.style.left + ')'
   }, [currSlideIdx])


   useEffect(() => {
      handleResize()
      if (!slides.length || !autoPlay) return
      let idx = intIdx
      const intervalId = setInterval(() => {
         handleClick(idx + 1)
      }, 4000);
      return () => clearInterval(intervalId);
   }, [slides, intIdx])


   const handleResize = () => {
      slides.forEach((slide, idx) => {
         slide.style.left = slides[0].getBoundingClientRect().width * idx + 'px';
      })
   }

   const handleClick = (idx) => {
      slidesRef.current?.classList?.add('transition')
      if (idx === slides.length) {
         slidesRef.current?.classList?.remove('transition')
         setCurrSlideIdx(0)
         setIntIdx(0)
      } else if (idx < 0) {
         slidesRef.current?.classList?.remove('transition')
         setCurrSlideIdx(slides.length - 1)
         setIntIdx(slides.length - 1)
      } else {
         setCurrSlideIdx(idx)
         setIntIdx(idx)
      }
      handleResize()
   }

   const handleTouchStart = (e) => {
      const touchDown = e.touches[0].clientX
      setTouchPosition(touchDown)
   }

   const handleTouchMove = (e) => {
      const touchDown = touchPosition
      if (touchDown === null) return
      const currentTouch = e.touches[0].clientX
      const diff = touchDown - currentTouch
      if (diff > 7) handleClick(currSlideIdx + 1)
      if (diff < -7) handleClick(currSlideIdx - 1)
      setTouchPosition(null)
   }

   return (
      <div onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} className='carousel-slider'>
         {slides.length > 2 && <button onClick={() => handleClick(currSlideIdx - 1)}>{svgs.arrowLeft}</button>}
         <div className="slides" ref={slidesRef}>
            {
               children.map((child, index) => (
                  <div key={index} data-index={index} className='slide' >
                     {child}
                  </div>
               ))
            }
            <div className='slide' >
               {children[0]}
            </div>
         </div>
         {slides.length > 2 && <button onClick={() => handleClick(currSlideIdx + 1)}>{svgs.arrowRight}</button>}
         {slides.length > 2 && <nav className="indicators" ref={indicatorsRef}>
            {
               data.map((item, index) => (
                  <button key={index} onClick={() => handleClick(index)} className={index === currSlideIdx || (currSlideIdx === slides.length - 1 && index === 0) ? 'indicator curr-indicator' : 'indicator'}>
                     <span></span>
                  </button>
               ))
            }
         </nav>}
      </div >
   )
}
